// src/services/api/water-meter.service.ts
import api from '../index';
import { WaterMeter } from '../../types/waterMeter';
import { Recommendation } from '../../types/maintenance';
import { AxiosResponse } from 'axios';

export const waterMeterService = {
  getAllMeters: () => 
    api.get<WaterMeter[]>('/meters'),

  getMeter: (id: number) => 
    api.get<WaterMeter>(`/meters/${id}`),

  getReadings: () => 
    api.get('/readings'),

  getLatestReading: () => 
    api.get('/readings/latest'),

  createMeter: (data: Partial<WaterMeter>) => 
    api.post<WaterMeter>('/meters', data),

  updateMeter: (id: number, data: Partial<WaterMeter>) => 
    api.put<WaterMeter>(`/meters/${id}`, data),

  deleteMeter: (id: number) => 
    api.delete(`/meters/${id}`),

  getMaintenanceRecommendations: (meterId: number) => 
    api.get<Recommendation[]>(`/meters/${meterId}/recommendations`),

  importReadings: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/readings/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  
};